/* corex-textil-editor-garment.js · La prenda del personalizador de camisetas.
   - Editor: prenda plana a las medidas de la talla, con la plantilla del tipo de prenda (corex-textil-editor-flat.js):
     editorFrame, drawEditorBase y drawMeasures.
   - Vista previa y JPG del carrito: fotos por color (frente, espalda y lateral de corex.packshots, con respaldos),
     con el diseño curvado al cuerpo (ancho del torso medido en la foto) y la máscara de la silueta: frameFor,
     drawBase y maskWith.
   - Color medio de la foto y límites de la prenda por talla (de la camiseta plana) para el tamaño máximo del diseño.
   Fotos por vista (corex.nivel y corex.foto_calibracion.fiable): la foto de una vista solo se usa si el color tiene
   packshot y la calibración de esa vista es fiable (la espalda y la manga exigen además el frente). Sin frente fiable,
   la vista previa dibuja la plantilla plana del editor teñida del color de la variante (medido en su foto); con frente
   pero sin espalda fiable, la espalda es la silueta de la foto frontal y la manga, la manga plana. Sin nivel ni
   fiable (productos calibrados a mano, como IB310) se usan todas las fotos.
   create(o) recibe del editor: data, cal, view(id), sideView, medFor(talla), sizes (orden de tallas), paintColor(),
   onChange(), template (clave de la plantilla plana; sin plantilla se usa la de camiseta-mc para no romper los
   cálculos, y el editor queda bloqueado).
   Sudaderas (plantillas con zonas recortadas, TPL.zoned): la zona útil de cada vista depende de la zona (pecho izq./dcha.
   de la cremallera) y del bolsillo; si la calibración trae el borde del bolsillo (cal.bolsillo, fracción de la foto) se
   usa ese en vez del estándar. */
(function () {
  'use strict';

  var G = window.CorexTextilGeo, IO = window.CorexTextilIO, FL = window.CorexTextilFlat;
  var FALLBACK_COLOR = 'rgb(128,128,128)';
  var TORSO_ROW = 0.6;      /* fila donde se mide el torso: 60 % del camino del hombro al bajo (bajo la sisa) */
  var TORSO_SAMPLE_W = 400; /* ancho de la copia reducida para medir */
  var PHOTO_BACK_NECK_CM = 1.5; /* cuello trasero de la foto bajo el punto alto del hombro (BACK_NECK_DROP_CM de geo) */

  /* corex.color_hex de un color ({ hex: '#RRGGBB', … }) como 'rgb(r,g,b)' (la plantilla mide la luminosidad de ese
     formato), o null si no hay o no es válido. */
  function hexRgb(h) {
    var m = h && /^#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i.exec(h.hex);
    return m ? 'rgb(' + parseInt(m[1], 16) + ',' + parseInt(m[2], 16) + ',' + parseInt(m[3], 16) + ')' : null;
  }

  /* Mitad del ancho del torso en la foto (px de la foto), midiendo el alfa desde el eje a cada lado; null sin CORS. */
  function torsoHalfPx(img, cal) {
    try {
      var w = TORSO_SAMPLE_W, f = img.naturalWidth / w, h = Math.round(img.naturalHeight / f);
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var y = Math.round((cal.top + TORSO_ROW * (cal.bottom - cal.top)) * h), d = ctx.getImageData(0, y, w, 1).data;
      var cx = Math.round(cal.cx * w), l = cx, r = cx;
      while (l > 0 && d[(l - 1) * 4 + 3] > 128) l--;
      while (r < w - 1 && d[(r + 1) * 4 + 3] > 128) r++;
      return r > l ? (r - l + 1) / 2 * f : null;
    } catch (e) {
      return null; /* imagen sin CORS: la vista previa queda plana */
    }
  }

  /* Vistas con foto del producto: { front, back, sleeve }. */
  function photoViews(nivel, cal) {
    var f = cal && cal.fiable;
    if (!f) { var all = !nivel || nivel === 'completo'; return { front: all, back: all, sleeve: all }; }
    return { front: !!f.frente, back: !!(f.frente && f.espalda), sleeve: !!(f.frente && f.manga) };
  }

  function create(o) {
    var garment = {}, TPL = FL.template(o.template, allMeds()) || FL.template('camiseta-mc'), PV = photoViews(o.data.nivel, o.cal);
    /* Capucha medida en la foto de espalda (cal.capucha), si la vista previa usa esa foto; si no, null (la estándar de la
       plantilla). La misma en el editor, el aviso y la vista previa. */
    var CAP = (PV.back && o.cal && o.cal.capucha) || null;
    /* Color sin fotos de la prenda: el de corex.color_hex si lo tiene (el mismo de la muestra del selector, medido en el
       pecho o corregido a mano); si no, se mide en su foto (packshot o imagen de la variante). La foto puede engañar: con
       modelo mide la piel, con fondo gris sale apagado, sobreexpuesta sale casi blanco (10239 Soft Yellow y Pink). */
    function flatGarment(name, url, hex) {
      var done = function (img) { garment[name] = { ready: true, flat: true, color: (img && G.sampleColor(img, o.cal)) || FALLBACK_COLOR }; o.onChange(); };
      if (hex) { garment[name] = { ready: true, flat: true, color: hex }; o.onChange(); return; }
      if (!url) { done(null); return; }
      IO.loadPhoto(url).then(done, function () { done(null); });
    }
    function ensureGarment(name) {
      if (garment[name]) return;
      var info = o.data.colors.filter(function (c) { return c.name === name; })[0] || {};
      var shots = (o.data.packshots || {})[name] || {};
      /* { galeria: true }: foto solo para «Fotos del producto» (otro encuadre o sin vistas fiables): aquí, silueta plana */
      if (shots.galeria) shots = {};
      var packshot = IO.packshotUrl(shots.face);
      garment[name] = { loading: true };
      if (!packshot || !PV.front) { flatGarment(name, packshot || info.photo, hexRgb(info.hex)); return; }
      Promise.all([IO.loadPhoto(packshot), IO.loadOptionalPhoto(PV.back && IO.packshotUrl(shots.back)), IO.loadOptionalPhoto(PV.sleeve && IO.packshotUrl(shots.side))]).then(function (r) {
        var cal = G.calibration(o.cal), front = torsoHalfPx(r[0], cal);
        garment[name] = { ready: true, img: r[0], back: r[1], side: r[2], color: G.sampleColor(r[0], o.cal) || FALLBACK_COLOR,
          torso: { front: front, back: r[1] ? torsoHalfPx(r[1], cal) : front } };
        o.onChange();
      }, function () {
        flatGarment(name, info.photo, hexRgb(info.hex)); /* packshot caído: silueta plana (su HEX o el color de la imagen de la variante) */
      });
    }
    /* Fotos de un color cargadas (para exportar su vista previa). */
    function loadGarment(name) {
      ensureGarment(name);
      return new Promise(function (resolve, reject) {
        (function wait() {
          var g = garment[name];
          if (g && g.ready) return resolve(g);
          if (g && g.error) return reject(new Error('No se ha podido cargar la foto del color ' + name + '.'));
          setTimeout(wait, 80);
        })();
      });
    }
    function silhouette(g, frame) {
      var key = frame.neckY.toFixed(1);
      if (!g.silhouette || g.silhouetteKey !== key) { g.silhouette = G.backSilhouette(g.img, frame, g.color); g.silhouetteKey = key; }
      return g.silhouette;
    }
    function frameFor(viewId, size) {
      var def = o.view(viewId), m = o.medFor(size), g = garment[o.paintColor()];
      if (def.kind === 'sleeve') {
        if (!(g && g.side && o.cal.manga)) return G.sleeveFrame(m);
        return G.photoSleeveFrame(g.side.naturalWidth, g.side.naturalHeight, o.cal, m, viewId !== o.sideView);
      }
      if (!(g && g.ready)) return null;
      if (g.img) return G.garmentFrame(g.img.naturalWidth, g.img.naturalHeight, o.cal, m, def.kind, g.torso[def.kind]);
      return flatFrame(m, def.kind);
    }
    function allMeds() { return o.sizes.map(function (t) { return o.data.medidas[t]; }).filter(Boolean); }
    /* Bolsillo de la foto: distancia del bajo a su borde superior (cm) en una talla; null sin calibración fiable. */
    function pocketCmFor(m) {
      var c = o.cal;
      if (!TPL.zoned || !c || c.bolsillo == null || !(c.bottom > c.top) || !(c.fiable && c.fiable.frente) || !m) return null;
      return m.largo * (c.bottom - c.bolsillo) / (c.bottom - c.top);
    }
    /* Vista previa sin foto: la prenda plana del editor, con su encuadre de la talla mayor. */
    function flatFrame(m, kind) {
      var all = allMeds(), f = TPL.bodyFrame(m, kind, all.length ? all : [m]);
      return Object.assign(f, { previewFlat: true, W: f.view.w, H: f.view.h, pocketCm: pocketCmFor(m) });
    }
    /* Silueta opaca de la prenda plana (máscara del diseño), en px del marco. */
    function flatMask(frame) {
      var key = [frame.kind, frame.med.pecho, frame.med.largo, frame.med.manga, frame.W, frame.H].join('|');
      if (!flatMask.cache || flatMask.key !== key) {
        var c = document.createElement('canvas');
        c.width = Math.ceil(frame.W); c.height = Math.ceil(frame.H);
        TPL.draw(c.getContext('2d'), frame, '#000000', { capucha: CAP });
        flatMask.cache = c; flatMask.key = key;
      }
      return flatMask.cache;
    }
    /* Centro y giro de la manga vista desde delante: en la foto, de la calibración (cal: manga_dx, manga_cy,
       manga_ang); en la plana, el centro de la manga dibujada y su eje. side: +1 derecha de la imagen. */
    function sleeveAnchor(frame, side, cal) {
      if (!frame.previewFlat) return { x: (cal.cx + side * cal.manga_dx) * frame.W, y: cal.manga_cy * frame.H, deg: -side * cal.manga_ang };
      var s = frame.shape, pts = [s.sp, s.ap, s.sht, s.shb];
      var u = pts.reduce(function (a, p) { return a + p.u; }, 0) / 4 * side, v = pts.reduce(function (a, p) { return a + p.v; }, 0) / 4;
      var at = frame.fwd(u, v);
      return { x: at.x, y: at.y, deg: Math.atan2(-side * s.dir.u, s.dir.v) * 180 / Math.PI };
    }
    /* Marco del editor: prenda (o manga) plana de la talla, con el encuadre de la talla mayor del producto. shown: medidas
       con las que se dibuja la silueta (a mitad de la transición al cambiar de talla); las cotas muestran las de size. */
    function editorFrame(viewId, size, shown) {
      var def = o.view(viewId), m = o.medFor(size), all = allMeds(), d = shown || m;
      if (!all.length) all = [m];
      var f = def.kind === 'sleeve' ? TPL.sleeveFrame(d, all) : TPL.bodyFrame(d, def.kind, all);
      return Object.assign(f, { labelMed: m, pocketCm: pocketCmFor(d) });
    }
    /* Sudaderas con capucha: detrás, la base va sin capucha y el editor la dibuja después encima del diseño
       (drawEditorHood, con la opacidad que toque). */
    function drawEditorBase(c, frame) { TPL.draw(c, frame, color(), { noHood: !!TPL.hasHood }); }
    function drawEditorHood(c, frame, alpha) { if (TPL.hasHood) TPL.drawHood(c, frame, color(), alpha, CAP); }
    /* Cuánto tapa la capucha bajada (cm) de una caja de diseño { x0, x1, y0, y1 } de detrás en una talla. */
    function hoodCover(size, box) { return TPL.hasHood ? TPL.hoodCover(o.medFor(size), box, CAP) : 0; }
    /* Zona útil de una vista en una talla (cm), con los márgenes del modelo. */
    function useful(viewId, size, margins) {
      var def = o.view(viewId), m = o.medFor(size);
      return TPL.useful(m, def.kind, margins, { split: def.split || 0, pocketCm: pocketCmFor(m) });
    }
    function drawBase(c, frame, kind) {
      var g = garment[o.paintColor()];
      if (frame.previewFlat) { TPL.draw(c, frame, color(), { capucha: CAP }); return; }
      if (kind === 'front') { G.drawPhoto(c, g.img, frame); return; }
      if (kind === 'back') {
        if (g.back) { G.drawPhoto(c, g.back, frame); return; }
        c.save();
        c.shadowColor = 'rgba(0,0,0,0.18)';
        c.shadowBlur = frame.pxPerCm * 0.8;
        c.drawImage(silhouette(g, frame), 0, 0);
        c.restore();
        return;
      }
      if (frame.photo) G.drawPhoto(c, g.side, frame);
      else G.drawSleeve(c, frame, color());
    }
    function maskWith(c, frame, kind) {
      var g = garment[o.paintColor()];
      c.globalCompositeOperation = 'destination-in';
      if (kind === 'sleeve') { c.fillStyle = '#000'; c.fill(frame.photo ? G.photoSleevePath(frame) : G.sleevePath(frame)); }
      else if (frame.previewFlat) c.drawImage(flatMask(frame), 0, 0, frame.W, frame.H);
      else if (kind === 'back') c.drawImage(g.back || silhouette(g, frame), 0, 0, frame.W, frame.H);
      else c.drawImage(g.img, 0, 0, frame.W, frame.H);
      /* capucha bajada: tapa el diseño por su silueta, como puesta */
      if (kind === 'back' && TPL.hasHood) {
        c.globalCompositeOperation = 'destination-out';
        c.fillStyle = '#000';
        c.fill(TPL.hoodPath(frame, CAP, frame.previewFlat ? null : PHOTO_BACK_NECK_CM));
      }
      c.globalCompositeOperation = 'source-over';
    }
    /* Límites de la prenda por talla, de la camiseta plana del editor (delante/detrás): ½ pecho y largo desde el
       cuello de la vista. */
    function garmentLimits(kind) {
      return o.sizes.reduce(function (acc, t) {
        var m = o.data.medidas[t];
        if (m) acc[t] = { halfW: m.pecho / 2, length: TPL.hemV(m, kind) };
        return acc;
      }, {});
    }
    /* Mangas: ancho del bajo de la manga en plano por talla (cm). */
    function sleeveLimits() {
      return o.sizes.reduce(function (acc, t) {
        var m = o.data.medidas[t];
        if (m) acc[t] = { hemW: TPL.sleeveHemW(m) };
        return acc;
      }, {});
    }
    /* { talla: límites } de una vista: { halfW, length } delante/detrás o { hemW } en mangas. */
    function limitsBySize(viewId) { var k = o.view(viewId).kind; return k === 'sleeve' ? sleeveLimits() : garmentLimits(k); }
    function get(name) { return garment[name]; }
    function color() { var g = garment[o.paintColor()]; return (g && g.color) || FALLBACK_COLOR; }
    return { ensure: ensureGarment, load: loadGarment, get: get, color: color, frameFor: frameFor, drawBase: drawBase, maskWith: maskWith, sleeveAnchor: sleeveAnchor,
      editorFrame: editorFrame, drawEditorBase: drawEditorBase, drawEditorHood: drawEditorHood, hoodCover: hoodCover, hasHood: !!TPL.hasHood, drawMeasures: FL.drawMeasures, useful: useful,
      garmentLimits: garmentLimits, limitsBySize: limitsBySize, zoned: !!TPL.zoned, cuffCm: TPL.cuffCm || 0 };
  }

  window.CorexTextilGarment = { create: create, photoViews: photoViews, FALLBACK_COLOR: FALLBACK_COLOR };
})();
